import React from "react";
import { useEffect, useState } from "react";
import { Interweave } from "interweave";

import { Doc } from "@uderly/react-uderly-ui/models";
import { getItemRequest } from "@uderly/react-uderly-ui/api";
import { DataLoader } from "@uderly/react-uderly-ui";
import { defaultSettings } from "@uderly/react-uderly-ui";

export interface LegalDocProps {
  docKey: string;
}

const LegalDoc = ({ docKey }: LegalDocProps) => {
  const [doc, setDoc] = useState<Doc | null>(null);

  useEffect(() => {
    const init = async () => {
      const response = await getItemRequest(`${defaultSettings.apiUrl}/docs/public/${docKey}?storeId=1`/*Settings.storeId as number*/);
      console.log(response)
      if (response && response.data)
        setDoc(response.data.data);
    }

    init();
  }, [docKey]);

  return <div className="page">
    <div className="legal-doc">
      {!doc &&
        <DataLoader fullscreen dark />}

      {doc && doc.text &&
        <Interweave content={doc.text} />}
    </div>
  </div>;
}

export default LegalDoc;